/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';
import { AuthProvider } from '@/context/AuthContext';
import { NotificationProvider } from '@/context/useNotificationContext';
import { ChildrenType } from '@/types/component-props';
import dynamic from 'next/dynamic';
import { ToastContainer } from 'react-toastify';
const LayoutProvider = dynamic(
  () => import('@/context/useLayoutContext').then((mod) => mod.LayoutProvider),
  {
    ssr: false,
  },
);

const AppProvidersWrapper = ({ children }: ChildrenType) => {
  // const session = useGetSession();
  // const handleChangeTitle = () => {
  //   if (document.visibilityState == 'hidden')
  //     document.title = 'Please come back 🥺';
  //   else document.title = DEFAULT_PAGE_TITLE;
  // };

  // useEffect(() => {
  //   if (document) {
  //     const e = document.querySelector<HTMLDivElement>('#__next_splash');
  //     if (e?.hasChildNodes()) {
  //       document.querySelector('#splash-screen')?.classList.add('remove');
  //     }
  //     e?.addEventListener('DOMNodeInserted', () => {
  //       document.querySelector('#splash-screen')?.classList.add('remove');
  //     });
  //   }

  //   document.addEventListener('visibilitychange', handleChangeTitle);
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleChangeTitle);
  //   };
  // }, []);

  return (
    // <SessionProvider>
    <AuthProvider>
      <LayoutProvider>
        <NotificationProvider>
          {children}
          <ToastContainer theme="colored" />
        </NotificationProvider>
      </LayoutProvider>
    </AuthProvider>
    // </SessionProvider>
  );
};
export default AppProvidersWrapper;
